/**
 * Selezione multipla a "chip" usata dai pannelli Pulsar (import nella Knowledge Base e
 * perimetro dell'Agente Analista). Le opzioni dipendono dall'enum dell'API usata: le
 * categorie dei historic (TRAC) non coincidono con le fonti di FilterInput (SourcesEnum).
 */

import type { ChipOption } from './options';

interface ChipSelectProps {
  options: readonly ChipOption[];
  selected: readonly string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

export function ChipSelect({ options, selected, onChange, disabled = false }: ChipSelectProps) {
  const toggle = (value: string) => {
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);
  };
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          disabled={disabled}
          onClick={() => toggle(o.value)}
          className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors disabled:opacity-50 ${
            selected.includes(o.value)
              ? 'bg-purple-700 border-purple-500 text-white'
              : 'bg-gray-800 border-gray-700 text-gray-400 hover:border-gray-500'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
